import { NationalityModel } from '../../../../../../../services/Settings/NationalityService';
import {
  SortDirection,
  TriOptionsModel,
} from '../../../../../../FrontDeskModule/Shared/components/FrontDeskToolbar';
import { ReservationCardGroupModel } from '../../../../../../ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface ArrivalReportFormModel {
  from: string | null;
  to: string | null;
  rate_ids: Array<number>;
  room_type_ids: Array<number>;
  card_ids: ReservationCardGroupModel[];
  states?: Array<string>;
  price: boolean;
  nationality_ids: NationalityModel[] | null;
  file_type: exportFileTypes;
  sortBy: TriOptionsModel;
  sortDirection: SortDirection;
  grouped: boolean;
  exclude_partial: boolean;
}

export enum ArrivalReportStateEnum {
  ARRIVAL = 'arrival',
  CHECKED_IN = 'checked_in',
  NO_SHOW = 'no_show',
}
